<template>
  <section class="@container">
    <header class="mb-8 grid grid-cols-[1fr_auto] gap-4">
      <div>
        <h3 class="mb-4 font-title text-3xl font-bold">
          {{ $t("brand.why_pollen_banner.title") }}
        </h3>
        <p class="font-semibold">
          {{ $t("brand.why_pollen_banner.subtitle") }}
        </p>
      </div>

      <app-button
        class="hidden md:flex"
        color="dark"
        to="/methodology"
        variant="outlined"
      >
        {{ $t("brand.why_pollen_banner.cta_label") }}
      </app-button>
    </header>

    <ul class="mt-12 grid gap-12 @xl:grid-cols-2 @3xl:grid-cols-3">
      <li
        v-for="(item, index) in list"
        :key="item.iconPath"
        class="flex flex-col items-center gap-8 text-center"
      >
        <app-image
          v-motion
          alt=""
          aria-hidden="true"
          class="h-[180px]"
          :height="220"
          :initial="{ opacity: 0, y: 20 }"
          :src="item.iconPath"
          :visible-once="{
            opacity: 1,
            y: 0,
            transition: {
              duration: 200,
              delay: index * 50,
              type: 'spring',
              stiffness: 250,
              damping: 25,
              mass: 0.5,
            },
          }"
        />

        <span
          class="min-h-[50px] [&>strong]:font-extrabold"
          :class="{ 'lg:text-xl': size === 'lg' }"
          v-html="item.title"
        />
      </li>
    </ul>

    <div class="mt-10 flex justify-center md:hidden">
      <app-button color="dark" to="/methodology" variant="outlined">
        {{ $t("brand.why_pollen_banner.cta_label") }}
      </app-button>
    </div>
  </section>
</template>

<script lang="ts" setup>
defineProps<{
  size?: "lg";
}>();

const { t } = useI18n();

const list = computed<{ iconPath: string; title: string }[]>(() => {
  return [
    {
      iconPath: "/images/illustrations/why_pollen_experts.svg",
      title: t("brand.why_pollen_banner.item_1_title"),
    },
    {
      iconPath: "/images/illustrations/why_pollen_active_learning.svg",
      title: t("brand.why_pollen_banner.item_2_title"),
    },
    {
      iconPath: "/images/illustrations/why_pollen_peers.svg",
      title: t("brand.why_pollen_banner.item_3_title"),
    },
  ];
});
</script>
